<form [formGroup]="formFiltro" (ngSubmit)="salvarOnClick()">

  <div class="row">
    <div class="form-group col-md-4">
      <label>Data Inicial de Envio da LIQ</label>
      <input id="dataInicial" formControlName="dataInicial"  type="date" class="form-control" 
        (change)="dataOnChange('dataInicial', 'dataFinal')"                         
        [ngClass]="{'is-invalid': formFiltro.controls['dataInicial'].errors && 
          (formFiltro.controls['dataInicial'].dirty || formFiltro.controls['dataInicial'].touched)}">
        <div class="invalid-feedback">
            <div *ngIf="formFiltro.controls['dataInicial'].errors?.required">Informe uma data.</div>
            <div *ngIf="formFiltro.controls['dataInicial'].errors?.validateMaxDate">{{msgErroMaxDataInicial}}</div> 
        </div> 
    </div>
    <div class="form-group col-md-4">
      <label>Data Final de Envio da LIQ</label>
      <input id="dataFinal" formControlName="dataFinal"  type="date" class="form-control"    
        (change)="dataOnChange('dataFinal', 'dataInicial')"                          
        [ngClass]="{'is-invalid': formFiltro.controls['dataFinal'].errors && 
          (formFiltro.controls['dataFinal'].dirty || formFiltro.controls['dataFinal'].touched)}">
        <div class="invalid-feedback">
            <div *ngIf="formFiltro.controls['dataFinal'].errors?.required">Informe uma data.</div>
            <div *ngIf="formFiltro.controls['dataFinal'].errors?.validateMinDate">A data deve ser posterior ou igual à data inicial.</div> 
            <div *ngIf="formFiltro.controls['dataFinal'].errors?.validateMaxDate">A data deve ser anterior ou igual à data atual.</div>  
        </div> 
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-4">
      <label>Nº do PED</label>
      <select id="escopoNumeroPed" formControlName="escopoNumeroPed" class="form-control custom-select"  
          (change)="escopoPedOnChange($event.target.value)">
          <option value="">Não especificado</option>
          <option *ngFor="let escopo of escopos" value={{escopo.id}}>
            {{escopo.descricao}}
          </option>
      </select>
    </div>
    <div class="form-group col-md-4">
      <label>{{labelNumPedInicial}}</label>
      <input id="numeroPedInicial" formControlName="numeroPedInicial" type="text" class="form-control" 
        [mask]="pedEmpLiqMask" [validation]="false"
        [ngClass]="{'is-invalid': formFiltro.controls['numeroPedInicial'].errors && 
          (formFiltro.controls['numeroPedInicial'].dirty || formFiltro.controls['numeroPedInicial'].touched)}">
        <div class="invalid-feedback">
            <div *ngIf="formFiltro.controls['numeroPedInicial'].errors?.required">Informe o número do PED.</div>
            <div *ngIf="formFiltro.controls['numeroPedInicial'].errors?.pattern">{{msgErroFormatoInvalido}}</div>
        </div>
    </div>
    <div *ngIf="exibirNumPedFinal" class="form-group col-md-4">
      <label>Final</label>
      <input id="numeroPedFinal" formControlName="numeroPedFinal" type="text" class="form-control" 
        [mask]="pedEmpLiqMask" [validation]="false"
        [ngClass]="{'is-invalid': formFiltro.controls['numeroPedFinal'].errors && 
        (formFiltro.controls['numeroPedFinal'].dirty || formFiltro.controls['numeroPedFinal'].touched)}">
      <div class="invalid-feedback">
          <div *ngIf="formFiltro.controls['numeroPedFinal'].errors?.pattern">{{msgErroFormatoInvalido}}</div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-4">
      <label>Nº do EMP</label>
      <select id="escopoNumeroEmp" formControlName="escopoNumeroEmp"  class="form-control custom-select" 
      (change)="escopoEmpOnChange($event.target.value)">
        <option value="">Não especificado</option>
        <option *ngFor="let escopo of escopos" value={{escopo.id}} >
          {{escopo.descricao}}
        </option>
      </select>
    </div>
    <div class="form-group col-md-4">
      <label>{{labelNumEmpInicial}}</label>
      <input id="numeroEmpInicial" formControlName="numeroEmpInicial" type="text" class="form-control" 
          [mask]="pedEmpLiqMask" [validation]="false"
          [ngClass]="{'is-invalid': formFiltro.controls['numeroEmpInicial'].errors && 
          (formFiltro.controls['numeroEmpInicial'].dirty || formFiltro.controls['numeroEmpInicial'].touched)}">
          <div class="invalid-feedback">
              <div *ngIf="formFiltro.controls['numeroEmpInicial'].errors?.required">Informe o número do EMP.</div>
              <div *ngIf="formFiltro.controls['numeroEmpInicial'].errors?.pattern">{{msgErroFormatoInvalido}}</div>
          </div>
    </div>
    <div *ngIf="exibirNumEmpFinal" class="form-group col-md-4">
      <label>Final</label>
      <input id="numeroEmpFinal" formControlName="numeroEmpFinal" type="text" class="form-control" 
          [mask]="pedEmpLiqMask"
          [ngClass]="{'is-invalid': formFiltro.controls['numeroEmpFinal'].errors && 
          (formFiltro.controls['numeroEmpFinal'].dirty || formFiltro.controls['numeroEmpFinal'].touched)}">
          <div class="invalid-feedback">
              <div *ngIf="formFiltro.controls['numeroEmpFinal'].errors?.pattern">{{msgErroFormatoInvalido}}</div>
          </div>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-4">
      <label>Nº da LIQ</label>
      <select id="escopoNumeroLiq" formControlName="escopoNumeroLiq"  class="form-control custom-select" 
      (change)="escopoLiqOnChange($event.target.value)">
        <option value="">Não especificado</option>
        <option *ngFor="let escopo of escopos" value={{escopo.id}}>
          {{escopo.descricao}}
        </option>
      </select>
    </div>
    <div class="form-group col-md-4">
      <label>{{labelNumLiqInicial}}</label>
      <input id="numeroLiqInicial" formControlName="numeroLiqInicial" type="text" class="form-control"
        [mask]="pedEmpLiqMask" [validation]="false"
        [ngClass]="{'is-invalid': formFiltro.controls['numeroLiqInicial'].errors && 
          (formFiltro.controls['numeroLiqInicial'].dirty || formFiltro.controls['numeroLiqInicial'].touched)}">
          <div class="invalid-feedback">
              <div *ngIf="formFiltro.controls['numeroLiqInicial'].errors?.required">Informe o número da LIQ.</div>
              <div *ngIf="formFiltro.controls['numeroLiqInicial'].errors?.pattern">{{msgErroFormatoInvalido}}</div>
          </div>
    </div>
    <div *ngIf="exibirNumLiqFinal" class="form-group col-md-4">
      <label>Final</label>
      <input id="numeroLiqFinal" formControlName="numeroLiqFinal" type="text" class="form-control"
        [mask]="pedEmpLiqMask" [validation]="false"
        [ngClass]="{'is-invalid': formFiltro.controls['numeroLiqFinal'].errors && 
          (formFiltro.controls['numeroLiqFinal'].dirty || formFiltro.controls['numeroLiqFinal'].touched)}">
          <div class="invalid-feedback">
              <div *ngIf="formFiltro.controls['numeroLiqFinal'].errors?.pattern">{{msgErroFormatoInvalido}}</div>
          </div>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-4">
      <label>Nº do Processo SEI:</label>   
      <input id="numeroProcessoSei" formControlName="numeroProcessoSei" type="text" class="form-control" 
          [mask]="processoSeiMask" [validation]="false"
          [ngClass]="{'is-invalid': formFiltro.controls['numeroProcessoSei'].errors && 
          (formFiltro.controls['numeroProcessoSei'].dirty || formFiltro.controls['numeroProcessoSei'].touched)}">
          <div class="invalid-feedback">
              <div *ngIf="formFiltro.controls['numeroProcessoSei'].errors?.pattern">{{msgErroFormatoInvalido}}</div>
          </div>
    </div>
    <div class="form-group col-md-8">
      <label>Histórico:</label>   
      <input id="historico" formControlName="historico" type="text" class="form-control"
          minlength="3" placeholder="Informe no mínimo 3 caracteres">
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-4">
      <label>Credor</label>
      <select id="tipoInformacaoCredor" formControlName="tipoInformacaoCredor" class="form-control custom-select"
      (change)="tipoInfoOnChange($event.target.value, 'informacaoCredor', false)">
        <option value="">Não especificado</option>
        <option *ngFor="let tipoInfo of tiposInfoCredor" value={{tipoInfo.id}} >
          {{tipoInfo.descricao}}
        </option>
      </select>
    </div>
    <div class="form-group col-md-4">
      <label>Valor</label>
      <input id="informacaoCredor" formControlName="informacaoCredor" type="text" class="form-control"
      [mask]="credorMask" [validation]="false"
      [ngClass]="{'is-invalid': formFiltro.controls['informacaoCredor'].errors && 
      (formFiltro.controls['informacaoCredor'].dirty || formFiltro.controls['informacaoCredor'].touched)}">
      <div class="invalid-feedback">
          <div *ngIf="formFiltro.controls['informacaoCredor'].errors?.required">{{msgErroCredorRequerido}}</div>
          <div *ngIf="formFiltro.controls['informacaoCredor'].errors?.pattern">{{msgErroFormatoInvalido}}</div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-4">
      <label>Credor da Consignatária</label>
      <select id="tipoInformacaoCredorConsignataria" formControlName="tipoInformacaoCredorConsignataria" class="form-control custom-select"
        (change)="tipoInfoOnChange($event.target.value, 'informacaoCredorConsignataria', true)">
        <option value="">Não especificado</option>
        <option *ngFor="let tipoInfo of tiposInfoCredor" value={{tipoInfo.id}} >
          {{tipoInfo.descricao}}
        </option>
      </select>
    </div>
    <div class="form-group col-md-4">
      <label>Valor</label>
      <input id="informacaoCredorConsignataria" formControlName="informacaoCredorConsignataria" type="text" class="form-control"
      [mask]="credorMaskConsignataria" [validation]="false" 
      [ngClass]="{'is-invalid': formFiltro.controls['informacaoCredorConsignataria'].errors && 
      (formFiltro.controls['informacaoCredorConsignataria'].dirty || formFiltro.controls['informacaoCredorConsignataria'].touched)}">
      <div class="invalid-feedback">
          <div *ngIf="formFiltro.controls['informacaoCredorConsignataria'].errors?.required">{{msgErroCredorConsignatariaRequerido}}</div>
          <div *ngIf="formFiltro.controls['informacaoCredorConsignataria'].errors?.pattern">{{msgErroFormatoInvalido}}</div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-4">
      <label>Valor da LIQ (R$)</label>
      <select id="escopoValorLiq" formControlName="escopoValorLiq" class="form-control custom-select" 
      (change)="escopoValorOnChange($event.target.value)">
        <option value="">Não especificado</option>
        <option *ngFor="let escopo of escopos" value={{escopo.id}}>
          {{escopo.descricao}}
        </option>
      </select>
    </div>
    <div class="form-group col-md-4">
      <label>{{labelValorLiqInicial}}</label>
      <input id="valorLiqInicial" formControlName="valorLiqInicial" type="text" class="form-control" 
      currencyMask [options]="{ precision: 2, prefix: '', thousands: '.', decimal: ',', allowNegative: false, allowZero: true}"      
      [ngClass]="{'is-invalid': formFiltro.controls['valorLiqInicial'].errors && 
        (formFiltro.controls['valorLiqInicial'].dirty || formFiltro.controls['valorLiqInicial'].touched)}">
        <div class="invalid-feedback">
          <div *ngIf="formFiltro.controls['valorLiqInicial'].errors?.required">Informe o valor da LIQ.</div>
        </div>
    </div>
    <div *ngIf="exibirValorLiqFinal" class="form-group col-md-4">
      <label>Final</label>
      <input id="valorLiqFinal" formControlName="valorLiqFinal" type="text" class="form-control" 
      currencyMask [options]="{ precision: 2, prefix: '', thousands: '.', decimal: ',', allowNegative: false, allowZero: true}">      
    </div>
  </div>

  <hr />
  <button class="btn btn-outline-primary" type="button" (click)="limparOnClick()">Limpar</button>
  <div class="form-group row pull-right">
    <div class="controls mr-2 col-md-12">
      <button class="btn btn-primary" type="submit">Confirmar</button>
      <button class="btn" type="button" (click)="cancelarOnClick()">Cancelar</button>
    </div>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/pagamento/relatorios/filtro-rel-liquidacao/filtro-rel-liquidacao.component.html